module.exports = __webpack_public_path__ + "img/xbj-03.8356eef3.svg";